import { toPostUI } from '../../../../../mappers/posts/toPostUI';
import { ContentPromotionPostsDialogHeader } from '../ContentPromotionPostsDialogHeader/ContentPromotionPostsDialogHeader';
import { ContentPromotionPostsDialogList } from '../ContentPromotionPostsDialogList/ContentPromotionPostsChoosingList';
import { ContentPromotionPostsDialogRow } from '../ContentPromotionPostsDialogRow/ContentPromotionPostsDialogRow';
import { ContentPromotionPostsDialogSkeleton } from '../ContentPromotionPostsDialogSkeleton/ContentPromotionPostsDialogSkeleton';
import { SKELETON_COUNT } from './constants';
import { Wrapper } from './styles';
import type { ContentPromotionPostsDialogContentProps } from './types';

export const ContentPromotionPostsDialogContent: React.FC<
    ContentPromotionPostsDialogContentProps
> = ({ posts, disabled, onSelect }) => (
    <Wrapper>
        <ContentPromotionPostsDialogHeader />
        <ContentPromotionPostsDialogList
            count={posts.items.length}
            renderItem={(index) => {
                const model = posts.items[index];

                if (model) {
                    return (
                        <ContentPromotionPostsDialogRow
                            key={model.id}
                            selected={!disabled[model.id]}
                            post={toPostUI(model)}
                            onSelect={(value) => onSelect(model.id, value)}
                        />
                    );
                }

                return <ContentPromotionPostsDialogSkeleton />;
            }}
        />
        {posts.isLoading
            ? new Array(SKELETON_COUNT)
                  .fill('')
                  .map((item, i) => <ContentPromotionPostsDialogSkeleton key={i} />)
            : null}
    </Wrapper>
);
